import effiMateLogo from "../assets/logo/effiMateLogo.png";
import effiMateLogoWhite from "../assets/logo/effiMateLogoWhite.png";
import rosterImage from "../assets/images/roster.png";
import rosterV2Image from "../assets/images/rosterv2.gif";
import homeImage from "../assets/images/home.gif";
import noDataImage from "../assets/images/noData.gif";
import noDashboardDataImage from "../assets/images/noDashboardDataImage.gif";
import analyticsNoDataFound from "../assets/images/analyticsNoDataFound.gif";
import employeeSearchImage from "../assets/images/employeeSearch.gif";
import CRM from "../assets/secondary-jobs/CRM.png";
import DM from "../assets/secondary-jobs/DM.png";
import PLAYGROUND from "../assets/secondary-jobs/PLAYGROUND.png";
import CASHIERING from "../assets/secondary-jobs/CASHIERING.png";
import CLICK_AND_COLLECT from "../assets/secondary-jobs/CLICK_AND_COLLECT.png";
import NA from "../assets/secondary-jobs/NA.png";
import EXTRACT from "../assets/images/extract.png";
import noCJPConfig from "../assets/images/noCJPConfig.gif";
import noCJPData from "../assets/images/noCJPData.gif";

// modules
import accessManagementIcon from "../assets/modules/access-management.png";
import dashboardIcon from "../assets/modules/dashboard.png";
import configurationIcon from "../assets/modules/configuration.png";
import layoutIcon from "../assets/modules/layout.png";
import leaveIcon from "../assets/modules/leave.png";
import migrationIcon from "../assets/modules/migration.png";
import myStoreIcon from "../assets/modules/my-store.png";
import ecoMobilityIcon from "../assets/modules/eco-mobility.png";
import payrollManualHoursIcon from "../assets/modules/payroll-manual-hours.png";
import secondaryIcon from "../assets/modules/secondary.png";
import swapRequestIcon from "../assets/modules/swap-request.png";
import workingHoursIcon from "../assets/modules/working-hours.png";
import integrationIcon from "../assets/modules/integration.png";

const SECONDARY_JOBS_ICONS: any = {
  CRM,
  DM,
  PLAYGROUND,
  CASHIERING,
  CLICK_AND_COLLECT,
  NA,
};
const MODULES_ICONS = {
  accessManagementIcon,
  configurationIcon,
  layoutIcon,
  leaveIcon,
  migrationIcon,
  myStoreIcon,
  ecoMobilityIcon,
  payrollManualHoursIcon,
  secondaryIcon,
  swapRequestIcon,
  workingHoursIcon,
  dashboardIcon,
  integrationIcon,
};

export {
  effiMateLogo,
  effiMateLogoWhite,
  rosterImage,
  rosterV2Image,
  homeImage,
  noDataImage,
  noDashboardDataImage,
  analyticsNoDataFound,
  employeeSearchImage,
  SECONDARY_JOBS_ICONS,
  EXTRACT,
  MODULES_ICONS,
  noCJPConfig,
  noCJPData,
};
